import(/* webpackMode: "eager" */ "/vercel/path0/app/(front)/bio/page.tsx");
